/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Vector3, Matrix4 } from 'three';
/**
 * Various helpers and utility methods in used in navigators.
 */
export class NavUtils {
    /**
     * Returns a function which calculates the current right vector from a camera
     */
    static calcCameraRight(getCamera) {
        const right = new Vector3();
        const dir = new Vector3();
        const up = new Vector3();
        return () => {
            const camera = getCamera();
            camera.matrix.extractBasis(right, up, dir);
            return right.clone().negate();
        };
    }
    /**
     * Returns a function which calculates the current lookAt vector from a camera
     */
    static calcLookAt(getCamera) {
        const lookAt = new Vector3();
        const pos = new Vector3();
        return (len) => {
            const camera = getCamera();
            camera.getWorldDirection(lookAt);
            camera.getWorldPosition(pos);
            if (len > 0) {
                lookAt.setLength(len);
            }
            lookAt.add(pos);
            return lookAt.clone();
        };
    }
    /**
     * Returns the pivot point from a camera. If not exists create a new one.
     * The default pivot is at [0, 0, 0].
     */
    static getPivot(camera) {
        let { pivot } = camera.userData;
        if (pivot == null) {
            pivot = new Vector3(0, 0, 0);
            camera.userData.pivot = pivot;
        }
        return pivot;
    }
    /**
     * Rotate a camera around an up vector. Optionally you can set a pivot point for the rotation.
     */
    static rotateCameraAround(position, lookAt, right, rotAroundUp, rotAngleUp, rotAngleRight, pivot) {
        const rotUp = new Matrix4();
        rotUp.makeRotationAxis(rotAroundUp, rotAngleUp);
        const rotRight = new Matrix4();
        rotRight.makeRotationAxis(right, rotAngleRight);
        const nextLookAt = lookAt.clone();
        if (pivot) {
            nextLookAt.sub(pivot);
        }
        nextLookAt.applyMatrix4(rotRight);
        nextLookAt.applyMatrix4(rotUp);
        if (pivot) {
            nextLookAt.add(pivot);
        }
        const nextCameraPosition = position.clone();
        if (pivot) {
            nextCameraPosition.sub(pivot);
        }
        nextCameraPosition.applyMatrix4(rotRight);
        nextCameraPosition.applyMatrix4(rotUp);
        if (pivot) {
            nextCameraPosition.add(pivot);
        }
        const up = nextLookAt.clone();
        up.sub(nextCameraPosition);
        up.cross(right);
        up.applyMatrix4(rotUp);
        up.normalize();
        const matrix = new Matrix4();
        matrix.lookAt(nextCameraPosition, nextLookAt, up);
        return {
            matrix,
            up,
            position: nextCameraPosition,
        };
    }
}
//# sourceMappingURL=NavUtils.js.map